import { render, staticRenderFns } from "./MainMenuHeader.vue?vue&type=template&id=769c6642&scoped=true&"
import script from "./MainMenuHeader.vue?vue&type=script&lang=js&"
export * from "./MainMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuHeader.vue?vue&type=style&index=0&id=769c6642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c6642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
installComponents(component, {VImg})
